var map = {
	"./pmt-backoffice/en": 527,
	"./pmt-backoffice/en.json": 527,
	"./pmt-backoffice/fr": 528,
	"./pmt-backoffice/fr.json": 528,
	"./pmt-order-plugin/de": 529,
	"./pmt-order-plugin/de.json": 529,
	"./pmt-order-plugin/en": 530,
	"./pmt-order-plugin/en.json": 530,
	"./pmt-order-plugin/es": 531,
	"./pmt-order-plugin/es.json": 531,
	"./pmt-order-plugin/fr": 532,
	"./pmt-order-plugin/fr.json": 532,
	"./pmt-order-plugin/it": 533,
	"./pmt-order-plugin/it.json": 533,
	"./pmt-web-kiosk/de": 534,
	"./pmt-web-kiosk/de.json": 534,
	"./pmt-web-kiosk/en": 535,
	"./pmt-web-kiosk/en.json": 535,
	"./pmt-web-kiosk/es": 536,
	"./pmt-web-kiosk/es.json": 536,
	"./pmt-web-kiosk/fr": 537,
	"./pmt-web-kiosk/fr.json": 537,
	"./pmt-web-kiosk/it": 538,
	"./pmt-web-kiosk/it.json": 538,
	"./pmt_web_customer/de": 539,
	"./pmt_web_customer/de.json": 539,
	"./pmt_web_customer/en": 540,
	"./pmt_web_customer/en.json": 540,
	"./pmt_web_customer/es": 541,
	"./pmt_web_customer/es.json": 541,
	"./pmt_web_customer/fr": 542,
	"./pmt_web_customer/fr.json": 542,
	"./pmt_web_customer/it": 543,
	"./pmt_web_customer/it.json": 543
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 788;